import Api from "./api";
import ApiV2 from "./apiV2"
import IdentityService from "./identityService"
import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";

export default class PrivateRoute extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isLoading: true,
      isLoggedIn: false
    };
  }

  async componentDidMount() {
    const isLoggedIn = await IdentityService.isLoggedIn();

    if (isLoggedIn){
      this.setState(() => ({ isLoading: false, isLoggedIn: true }));
    } else {
      console.log("Unable to get logged in User");
      this.setState(() => ({ isLoading: false, isLoggedIn: false }));
    }
  }

  render() {
    if (this.state.isLoading) {
      return null;
    } else {
      if (this.state.isLoggedIn) {
        return (
          <Route path={this.props.path} exact={this.props.exact}>
            {this.props.component}
          </Route>
        );
      }
      return (
        <Redirect
          to={{ pathname: "/login", state: { from: this.props.location } }}
        />
      );
    }
  }
}
